import styled from 'styled-components';
import { ApplicationWarnings, ApplicationWarningsProps } from 'omni-package-react-core';
import { FC } from 'react';

export const StyledApplicationWarnings = styled<FC<{ marginBottom: number } & ApplicationWarningsProps>>(ApplicationWarnings)`
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;
